import React from 'react';
import { TimeFrame } from 'models/ReportData';
import { formatSecToHourString } from 'helpers/conversions';
import { ITopCardsProps } from './TopCardsContainer';
import { Box } from '@mui/material';
import { dashboardIcon, likeIcon, productionIcon } from '../Icons';
import TotalImpressionCardMobileDtf from '../TotatImpressionCardMobile';
import ProductionRateCardMobileDtf from '../ProductionRateCardMobileDtf';
import AvailabilityCardMobileDtf from '../AvailabilityCardMobileDtf';
import { styles } from './OverviewTopCard.styles';

const MobileDtfTopCards = (props: ITopCardsProps) => {
  const {
    timeframe,
    totalProduction,
    productionTrend,
    productionRate,
    productionRateTrend,
    utilization,
    trendUtilization,
    preparation,
    trendPreparation,
    availability,
    availabilityTrend,
    errorDuration,
    errorDurationTrend,
    maintenanceDuration,
    maintenanceDurationTrend,
    selectedSystemGroup,
    selectedSystemGroupText,
    units,
  } = props;
  const getTimeframeTextKey = () => {
    return timeframe && timeframe.includes('lastUpdate') ? 'last' : 'weekDay';
  };
  const changeTextPerPage = (timeframe: TimeFrame | '', text: string) => {
    if (timeframe && timeframe.includes('lastUpdate')) return text.replace('Average', 'Current');
    return text;
  };
  return (
    <>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <TotalImpressionCardMobileDtf
          value={totalProduction}
          units={units}
          icons={productionIcon(selectedSystemGroup)}
          description={selectedSystemGroupText.impression.description[getTimeframeTextKey()]}
          stats={productionTrend}
          statsDescription={selectedSystemGroupText.impression.statsDescription[getTimeframeTextKey()]}
          cardName="totalProduction"
        />
      </Box>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <ProductionRateCardMobileDtf
          selectedSystemGroup={selectedSystemGroup}
          value={productionRate}
          units={units + '/h'}
          icons={dashboardIcon}
          description={selectedSystemGroupText.productionRate.description[getTimeframeTextKey()]}
          stats={productionRateTrend}
          statsDescription={
            selectedSystemGroupText.productionRate.statsDescription[getTimeframeTextKey()]
          }
          addedData={{
            upper: {
              unit: '%',
              value: utilization,
              description: changeTextPerPage(timeframe, selectedSystemGroupText.productionRate.upper),
              trend: trendUtilization,
            },
            lower: {
              value: preparation,
              description: selectedSystemGroupText.productionRate.lower,
              unit: '%',
              trend: trendPreparation,
            },
          }}
          cardName="averageProductionRate"
        />
      </Box>
      <Box display="flex" width="100%" minHeight="130px" boxSizing="border-box" sx={styles.wrapper}>
        <AvailabilityCardMobileDtf
          cardName="availability"
          value={availability}
          units={'%'}
          icons={likeIcon}
          isPercentage={true}
          description={selectedSystemGroupText.availability.description[getTimeframeTextKey()]}
          stats={availabilityTrend}
          statsDescription={
            selectedSystemGroupText.availability.statsDescription[getTimeframeTextKey()]
          }
          addedData={{
            upper: {
              unit: '',
              value: errorDuration,
              description: selectedSystemGroupText.availability.upper,
              trend: errorDurationTrend,
              formatter: formatSecToHourString,
            },
            lower: {
              value: maintenanceDuration,
              unit: '',
              description: selectedSystemGroupText.availability.lower,
              trend: maintenanceDurationTrend,
              formatter: formatSecToHourString,
            },
          }}
        />
      </Box>
    </>
  );
};

export default MobileDtfTopCards;
